import { FC } from 'react';

import Button from '@/components/controls/Button';

type CustomConfirmToastProps = {
  header: string;
  show: boolean;
  message: string;
  onAccept: () => void;
  onDecline: () => void;
};

const CustomConfirmToast: FC<CustomConfirmToastProps> = ({
  header,
  show,
  message,
  onAccept,
  onDecline,
}) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
      <div className="flex flex-col bg-white rounded-lg shadow-lg p-6 w-[calc(100%-2rem)] sm:w-full max-w-md text-gray-800">
        <h2 className="self-start text-xl font-semibold mb-4">{header}</h2>
        <p className="mb-4 self-start text-lg">{message}</p>
        <div className="flex flex-col sm:flex-row sm:justify-end gap-3 sm:gap-4 sm:space-x-0 mt-4 text-lg">
          <Button
            buttonStyle="px-5 py-2 bg-primary-100 hover:bg-primary-200 text-white rounded-xl w-full sm:w-auto"
            text="Confirm"
            buttonType={{ type: 'button' }}
            hasImage={false}
            onClick={onAccept}
          />

          <Button
            buttonStyle="px-5 py-2 bg-inherit hover:bg-gray-100 border border-primary-100 text-primary-100 rounded-xl w-full sm:w-auto"
            text="Cancel"
            buttonType={{ type: 'button' }}
            hasImage={false}
            onClick={onDecline}
          />
        </div>
      </div>
    </div>
  );
};

export default CustomConfirmToast;
